import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
// Routes
import Home from './routes/Home';
import Service from './routes/Service';
import About from './routes/About';
import Contact from './routes/Contact';
// Components
import Navbar from './components/Navbar'
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
      
        <div className='page_body'>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Home section="Services" />} />
            <Route path="/service/:id" element={<Service />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </div>

        <Footer />
      </Router>
    </div>
  );
}

export default App;
